import { useState } from "react"
import getEmbedUrl from "better-video-embeds"

import { Img } from "../../../layout/Img"
import { FaPlayCircle } from "../../../svgIcons"
import { LinkField } from "../../linkField"

const bgColors = {
  blackWhite: "bg-white text-secondary",
  blackLightBlue: "bg-bgmain text-secondary",
  blackRed: "bg-bgcardtwo text-secondary",
  whiteCoreBlue: "bg-primary text-white",
}

const cardStyles = {
  squaredPicture: { rounded: false, reversed: false },
  squaredPictureReversed: { rounded: false, reversed: true },
  roundedPicture: { rounded: true, reversed: false },
  roundedPictureReversed: { rounded: true, reversed: true },
}

export const FeaturedCard = ({
  style,
  cardBGColor,
  cardContent,
  cardPicture,
  cardCTALink,
  videoUrl,
}) => {
  // For Modal
  const [showModal, setShowModal] = useState(false)

  const embedLink = getEmbedUrl(videoUrl)

  return (
    <>
      <section className="container mx-auto md:w-9/12">
        <div
          className={`flex flex-col items-center mx-4 lg:flex-row ${bgColors[cardBGColor]}`}
        >
          {cardPicture && cardPicture.length > 0 && (
            <div
              className={`flex-initial ${
                cardStyles[style].rounded && "lg:flex-auto order-first"
              } ${cardStyles[style].reversed && "xl:order-last"}`}
            >
              <div className="relative flex items-center justify-center">
                <Img
                  image={cardPicture[0]}
                  className={`${
                    cardStyles[style].rounded && "flex-auto rounded-full m-4"
                  }`}
                />
                {videoUrl && videoUrl.length > 0 && (
                  <button
                    className="absolute inset-0 w-16 h-16 m-auto"
                    type="button"
                    onClick={() => setShowModal(true)}
                  >
                    <FaPlayCircle className="w-16 h-16 text-white" />
                  </button>
                )}
              </div>
            </div>
          )}
          <div className="flex-auto pt-4">
            <div className="gap-4 px-4 pt-4 md:p-10">
              <div
                className="pb-4 text-left redactor"
                dangerouslySetInnerHTML={{ __html: cardContent }}
              />
              {cardCTALink && (
                <div className="flex justify-center my-4 xl:justify-start">
                  <LinkField
                    {...cardCTALink}
                    className="inline-block px-10 py-4 font-semibold text-center text-white rounded bg-pink hover:bg-btnhover"
                  >
                    {cardCTALink.text}
                  </LinkField>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Playing Video */}
      {showModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none justify-items-center">
            <div className="relative w-9/12 h-full mx-auto">
              <div className="flex flex-col w-full p-4 border-0 rounded-lg shadow-lg outline-none h-5/6 bg-secondary focus:outline-none">
                <button
                  type="button"
                  className="float-right ml-auto font-semibold leading-none bg-transparent border-0 outline-none text-secondary focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="w-6 h-6 text-2xl text-white">×</span>
                </button>

                <div
                  id="responsiveVideoWrapper"
                  className="relative flex-auto h-0 pb-fluid-video"
                >
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src={embedLink}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Featured Video"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 opacity-80 bg-primary" />
        </>
      )}
    </>
  )
}
